/**
 *  @utils 
*/

/**
 *  @邮箱验证
*/
var emailYz = (a) => {//验证，汉字，字母，数字集合
	var tes = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
	return tes.test(a);
};

/**
 *  @手机号正则表达式验证
*/
function checkPhone(a){ 
	var tes = (/^1[3456789]\d{9}$/);
	return tes.test(a);
};

module.exports = {
	emailYz,//邮箱验证
	checkPhone,//手机号验证
};


// WEBPACK FOOTER //
// ./src/utils/utils.js